import { useQuery, UseQueryOptions, QueryKey } from "@tanstack/react-query";

interface UseCustomQueryParams<T> {
	queryKey: QueryKey;
	queryFn: () => Promise<T>;
	options?: Omit<UseQueryOptions<T>, "queryKey" | "queryFn">;
}

/**
 * Custom hook that wraps the useQuery hook to add default configurations and handle errors.
 * @param {UseCustomQueryParams<T>} params - Object containing queryKey, queryFn, and options.
 * @returns {ReturnType<typeof useQuery>} - Return value of useQuery.
 */
export const useCustomQuery = <T>({
	queryKey,
	queryFn,
	options,
}: UseCustomQueryParams<T>) => {
	return useQuery<T>({
		queryKey,
		queryFn,
		retry: 2,
		refetchOnWindowFocus: false,
		staleTime: 1000 * 60 * 5,
		gcTime: 1000 * 60 * 10,
		...options,
	});
};
